import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-0"}],["path",{"d":"M4 21l3 -4","key":"svg-1"}],["path",{"d":"M13 21l-2 -4l-3 -3l1 -6","key":"svg-2"}],["path",{"d":"M3 12l2 -3l4 -1l6 4","key":"svg-3"}],["path",{"d":"M16.5 14l3.5 7","key":"svg-4"}]]

const IconBlind = createReactComponent('outline', 'blind', 'Blind', __iconNode);

export default IconBlind;